import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export default function LastFormSaveModal(props) {
  
const {lastFormSaveModalOpen, setLastFormSaveModalOpen,setConfirmRedirect} = props;

  return (
    <Dialog
      open={lastFormSaveModalOpen}
      // onClose={() => handleClose(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContent>
        You have reached the last form, do you want to redirect to the My Drafts page?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {setConfirmRedirect(false),setLastFormSaveModalOpen(false)}} variant="outlined" color="primary">
          No
        </Button>
        <Button onClick={() => {setConfirmRedirect(true)}} color="primary" autoFocus style={{ backgroundColor: '#010160', color: 'white' }}>
           Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}


